import { render, staticRenderFns } from "./btramto_new.vue?vue&type=template&id=29e55523"
import script from "./btramto_new.vue?vue&type=script&lang=js"
export * from "./btramto_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports